export default __webpack_public_path__ + "f3de8ce58b82113f55420127325ed810.png";